import React from "react";
import { memo } from "react";

import { useIsClientSide } from "@utils/hooks/isClient.hook";

import { useSearchRouting } from "./useSearchRouting";

type SyncRouteProps = {
    ignoreQuery: boolean;
};

const _SyncRoute = ({ ignoreQuery }: SyncRouteProps) => {
    useSearchRouting(ignoreQuery);

    return null;
};

export const SyncRoute = memo(({ ignoreQuery }: SyncRouteProps) => {
    const isClientSide = useIsClientSide();

    if (!isClientSide) return null;

    return <_SyncRoute ignoreQuery={ignoreQuery} />;
});
